/* Header USPs */
const headerUspEl = document.querySelector('.headerUsp-swiper');

if (headerUspEl) {
  new Swiper(headerUspEl, {
    slidesPerView: 1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next.usps",
      prevEl: ".swiper-button-prev.usps",
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1540: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      1660: {
        slidesPerView: 5,
        spaceBetween: 16,
      },
    },
  });
}

/* Featured Collection */
document.querySelectorAll('.collectionSwiper').forEach((swiperEl, index) => {
  const slidesPerView = parseInt(swiperEl.dataset.slidesPerView) || 4;

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.swiper-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.swiper-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1660: {
        slidesPerView: slidesPerView,
        spaceBetween: 16,
      },
    },
  });
});

/* Testimonials */
document.querySelectorAll('.testimonialsSwiper').forEach((swiperEl, index) => {
  const slidesPerView = parseInt(swiperEl.dataset.slidesPerView) || 4;

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.testimonials-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.testimonials-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1440: {
        slidesPerView: slidesPerView,
        spaceBetween: 16,
      },
    },
  });
});

/* Enquiry Testimonials */
document.querySelectorAll('.testimonialsEnquirySwiper').forEach((swiperEl, index) => {
  const slidesPerView = parseInt(swiperEl.dataset.slidesPerView) || 1;

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.testimonials-enquiry-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.testimonials-enquiry-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    autoHeight: true,
    rewind: true,
    slidesPerView: slidesPerView,
    spaceBetween: 16,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    }
  });
});

/* Team Members */
document.querySelectorAll('.memberSwiper').forEach((swiperEl, index) => {

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.member-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.member-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    spaceBetween: 16,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1660: {
        slidesPerView: 5,
        spaceBetween: 16,
      },
    }
  });
});

/* Team Members */
document.querySelectorAll('.brandSwiper').forEach((swiperEl, index) => {

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.brand-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.brand-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    spaceBetween: 16,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1660: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    }
  });
});



/* Sub Collections */
document.querySelectorAll('.subCollectionSwiper').forEach((swiperEl, index) => {

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.subCollection-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.subCollection-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    freeMode: true,
    rewind: true,
    autoHeight: false,
    slidesPerView: 3,
    spaceBetween: 8,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      800: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1000: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      1400: {
        slidesPerView: 6,
        spaceBetween: 16,
      },
       1660: {
         slidesPerView: 8,
         spaceBetween: 16,
       },
    }
  });
});

/* Hero */
document.querySelectorAll('.heroSwiper').forEach((swiperEl, index) => {

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.hero-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.hero-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
       delay: 8000,
       disableOnInteraction: false,
    },
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    }
  });
});

// Related Blog Posts
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.postsSwiper').forEach((swiperEl) => {

    const container = swiperEl.closest('.posts-wrapper-container');

    const nextBtn = container?.querySelector('.button-next-swiper');
    const prevBtn = container?.querySelector('.button-prev-swiper');

    const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

    // Show navigation on mobile ALWAYS
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (!isMobile) {
      // Desktop/tablet logic: hide navigation if 4 or fewer slides
      if (slidesCount <= 4) {
        if (nextBtn) nextBtn.style.display = 'none';
        if (prevBtn) prevBtn.style.display = 'none';
      }
    } else {
      // Ensure nav is visible on mobile
      if (nextBtn) nextBtn.style.display = '';
      if (prevBtn) prevBtn.style.display = '';
    }

    new Swiper(swiperEl, {
      spaceBetween: 16,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1660: {
          slidesPerView: 4,
        },
      }
    });

  });

});



/* Popular Equipment */
document.querySelectorAll('.equipmentSwiper').forEach((swiperEl, index) => {

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.equipment-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.equipment-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    spaceBetween: 16,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      1660: {
        slidesPerView: 5,
        spaceBetween: 16,
      },
    }
  });
});
